import styled from '@emotion/styled';
import { FC } from 'react';

import { ThinEvent } from '@/resources/ThinEvent';
import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { Skeleton } from '../core/Skeleton/Skeleton';

const Wrapper = styled.div<IThemeProps>`
  margin: 84px 20px 34px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin: 76px 32px 32px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin: 104px 72px 42px;
  }
`;

const Title = styled.h2<IThemeProps>`
  margin: 0;
  font-size: 24px;
  line-height: 32px;
  color: ${({ theme }) => theme.legacy.colors.black};

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    font-size: 32px;
    line-height: 40px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    font-size: 48px;
    line-height: 56px;
  }
`;

interface IEventTitleProps {
  event: ThinEvent;
}

export const EventTitle: FC<IEventTitleProps> = ({ event }) => {
  return (
    <Wrapper>
      {event ? <Title>{event.name}</Title> : <Skeleton css={{ width: '100%', height: 30, marginBottom: 30 }} />}
    </Wrapper>
  );
};
